// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YqHsAJkrg6cViag0IIWo{padding:0 8px 16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `YqHsAJkrg6cViag0IIWo`
};
export default ___CSS_LOADER_EXPORT___;
